// extracted by mini-css-extract-plugin
export default {"container":"feed-list_container__kVa8Q","list":"feed-list_list__0smdi"};